<template>
    <div>
        <ScreenOverlay
            v-if="show"
            @click="$emit('close')"
        />

        <div class="relative">
            <div class="cursor-pointer flex items-center gap-4 justify-end">
                <slot name="content" />
            </div>
            <div
                v-if="show"
                class="absolute w-48 z-50"
                :class="{
                    'left-0': horizonalPosition === 'right',
                    'right-0': horizonalPosition === 'left',
                    'top-full': verticalPosition === 'bottom',
                    'bottom-full': verticalPosition === 'top',
                }"
            >
                <div class="bg-white mt-1 p-2 rounded-xl shadow-xs">
                    <slot name="items" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import ScreenOverlay from '@/Shared/Component/ScreenOverlay.vue'

    defineEmits(['close'])

    defineProps({
        show: {
            type: Boolean,
            default: false,
        },
        horizonalPosition: {
            type: String as PropType<'left' | 'right'>,
            default: 'left',
        },
        verticalPosition: {
            type: String as PropType<'top' | 'bottom'>,
            default: 'bottom',
        },
    })
</script>
